import { api } from "@/lib/api";

export type DocumentFolder = {
  id: string;
  name: string;
};

export type DocumentItem = {
  id: string;
  title: string;
  original_filename: string;
  content_type: string | null;
  size_bytes: number | null;
  requires_ack: boolean;
  acknowledged_at: string | null;
  created_at: string | null;
  folder: DocumentFolder | null;
};

export type DocumentsListResponse = {
  folders: DocumentFolder[];
  docs: DocumentItem[];
  page: number;
  page_size: number;
  total_count: number;
  total_pages: number;
  page_pending: number;
  page_signed: number;
  filters: { folder_id: string | null; status: string | null };
};

export type DocumentDetail = DocumentItem & {
  view_url: string | null;
  is_pdf: boolean;
  is_image: boolean;
  can_view: boolean;
  can_ack: boolean;
};

export type DocumentStatusFilter = "" | "pending" | "signed";

export async function fetchMyDocuments(params: {
  page?: number;
  page_size?: number;
  folder_id?: string | null;
  status?: DocumentStatusFilter;
}): Promise<DocumentsListResponse> {
  const q: Record<string, string | number> = {
    page: params.page ?? 1,
    page_size: params.page_size ?? 20,
  };
  if (params.folder_id) q.folder_id = params.folder_id;
  if (params.status) q.status = params.status;
  const { data } = await api.get<DocumentsListResponse>("/api/web/documents/my", {
    params: q,
  });
  return data;
}

export async function fetchDocumentDetail(id: string): Promise<DocumentDetail> {
  const { data } = await api.get<DocumentDetail>(`/api/web/documents/${id}`);
  return data;
}

export async function ackDocument(id: string): Promise<DocumentDetail> {
  const { data } = await api.post<DocumentDetail>(`/api/web/documents/${id}/ack`);
  return data;
}

export async function fetchDocumentDownloadUrl(id: string): Promise<string> {
  const { data } = await api.get<{ url: string }>(
    `/api/web/documents/${id}/download-url`
  );
  return data.url;
}
